export const ERROR_MESSAGE = {
  ACCESS_DENIED: 'Access Denied',
};
